import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import { AppContext } from './components/context';
import ScrollIntoView from './components/ScrollIntoView';
import { Homepage, BookOnline } from './components/pages';
import userAgent from './components/userAgent';

const App = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const {
    isMobile,
    mobileDeviceName
  } = userAgent();

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <Router onUpdate={() => window.scrollTo(0, 0)}>
      <AppContext.Provider value={{
          isLoaded: isLoaded,
          userAgent: { isMobile: isMobile, name: mobileDeviceName },
          aggregateRating: { count: 4.35, ratings: 540 }
        }}
      >
        <ScrollIntoView>
          <Switch>
            <Route path="/" component={Homepage} exact />
            <Route path="/book-online" component={BookOnline} />
          </Switch>
        </ScrollIntoView>
      </AppContext.Provider>
    </Router>
  );
}

export default App;
